import { connect } from 'react-redux';
import ViewerRetrieveStudyData from './ViewerRetrieveStudyData.js';
import OHIF from 'ohif-core';
import { redux } from '../api';
const { setViewportSpecificData } = OHIF.redux.actions;
const isActive = a => a.active === true;
const { setAIProductDetailInfo, setAiProductHeatmapData } = redux.actions;
const { setApplicationInfo } = redux.actions;
const mapStateToProps = state => {
  const activeServer = state.servers.servers.find(isActive);
  const { layout, viewportSpecificData } = state.viewports;
  return {
    server: activeServer,
    layout,
    viewportSpecificData,
    applicationInfo: state.api.current.applicationInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setAIProductDetailInfo: data => dispatch(setAIProductDetailInfo(data)),
    setAiProductHeatmapData: data => dispatch(setAiProductHeatmapData(data)),
    setViewportSpecificData: (viewportIndex, data) =>
      dispatch(setViewportSpecificData(viewportIndex, data)),
    setApplicationData: data => dispatch(setApplicationInfo(data)),
  };
};

const ConnectedViewerRetrieveStudyData = connect(
  mapStateToProps,
  mapDispatchToProps
)(ViewerRetrieveStudyData);

export default ConnectedViewerRetrieveStudyData;
